import { gql } from "@apollo/client";export default gql`mutation AddGroupWorksheetMap(
    $objects: [worksheet_group_worksheet_map_insert_input!]!
) {
    addGroupTabMap: insert_worksheet_group_worksheet_map(objects: $objects) {
        affected_rows
    }
}
`;
